const UserReducer = (
    state =
        {
            date: '',
            birth: {},
            email: '',
            user: {},
            name: '',
            subscription: true,
            willLast: {},
            params: {}
        }, action) => {
    switch (action.type) {
        case 'IDENTIFY_USER':
            return {
                ...state,
                user: action.user
            };
        case 'SET_DAY_OF_BIRTH':
            return {
                ...state,
                date: action.date,
                birth: action.birth
            };
        case 'SET_EMAIL':
            return {
                ...state,
                email: action.email
            };
        case 'SET_NAME':
            return {
                ...state,
                name: action.name
            };   
        case 'SUBSCRIBE':
            return {
                ...state,
                subscription: action.subscription
            };                        
        case 'SET_BIKE_WILL_LAST':
            return {
                ...state,
                willLast: action.willLast
            }
        case 'PAGE_PARAMS':
            return {
                ...state,
                params: action.params
            }
        default:
            return state;
    }
};

export default UserReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/UserReducer.js